import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { PortalAuthenticationService } from '../_services/dx-portal-auth.service';
import { GlobalsService } from '../_core/globals.service';


@Injectable()
export class AuthSsoInterceptor implements HttpInterceptor {
  constructor(private globalSvc: GlobalsService, private portalAuthSvc: PortalAuthenticationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
   
    let loggedOnUser = this.portalAuthSvc.getLoggedOnUser;      
    if (loggedOnUser) {      
      request = request.clone({
        headers: request.headers.set('Authorization', `Bearer ${loggedOnUser.oauthToken?.id_token}`)
      });
    }    
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        this.portalAuthSvc.showLoader = false;
        return throwError(() => error);
    })

    )
  }
}
